const seoMetaMap = {
    all: {
        title: 'Free Cricket Live Streaming on PBC88 Bangla | PBC88 Live',
        description: 'Watch free live cricket streaming on PBC88 Bangla and enjoy uninterrupted coverage of your favorite matches in high quality. Stay updated with live scores, expert commentary, and exclusive match highlights—all for free on PBC88 Bangla!',
    },
    cricket: {
        title: "Today's cricket match live score | PBC88 Live",
        description: "Get real-time updates on today’s cricket match live scores along with the latest trends from the cricket exchange market. Track ball-by-ball commentary, player statistics, and dynamic odds from leading cricket trading platforms. Stay ahead with live match data, market fluctuations, and expert insights—all in one place!",
    },
    football: {
        title: "Live football - watch the game in real time!",
        description: "Every exciting moment of live football! Keep an eye on football events, live score updates and schedule commentary at PBC888 Live. Whether you are a football fan or just love score betting, you can experience the charm of football here!",
    },
    basketball: {
        title: "NBA Live News - Basketball Score App!",
        description: "Watch today's NBA (Basketball) results! Bet on live games, ESPN scores, schedules, points, odds, register on PBC888 official website for the latest information.",
    },
    tennis: {
        title: "Live Tennis Matches - Every Serve, Every Rally, Every Point!",
        description: "Don't miss every swing of every live tennis match! Watch the world's top players compete in real time, and experience lightning serves, powerful rallies and thrilling match points. Stay tuned for PBC888 expert analysis, live scores and all the excitement on the court!",
    },
    esports: {
        title: "Live eSports Arena - Players Create Legends!",
        description: "Enter the live eSports world (PBC88 LOL) and witness the real-time duel between elite players! Whether it is a first-person shooter (FPS), a multiplayer online tactical competitive game (MOBA) or a battle royale game, you will have an exciting battle experience!",
    }
};

export default seoMetaMap;
